<template>
  <!-- upload控件 -->
  <div>
    <div
      class="upload"
      v-show="isShow"
      :class="[ listType === 'text' ? 'textType' : 'notextType' ]"
    >
      <el-upload
        ref="uploadCommon"
        action="upload"
        :http-request="uploadRequest"
        :name="name"
        :isAlone="isAlone"
        :list-type="listType"
        :show-file-list="false"
        :file-list="uploadFileList"
        :multiple="multiple"
        :limit="limit"
        :auto-upload="true"
        :disabled="textUploadDisabled"
        :accept="accept"
        :drag="drag"
        :before-upload="beforeUploadHandler"
        :on-error="errorHandle"
        :on-exceed="exceedHandle"
        :class="{ drag: drag }"
        v-show="isTextType || fileList.length < limit"
      >
        <!-- 已上传的文件个数 小于 限制上传的个数则不再显示上传组件 -->
        <div class="el-upload__image" v-if="!isTextType && (fileList.length < limit) ">
          <div class="el-upload__image__icon"></div>
        </div>
        <div class="el-upload__text" :class="{'el-upload__text': true, 'text-upload-disabled': textUploadDisabled}"  v-if="isTextType">
          <div class="el-upload__text__icon"></div>
          <span class="el-upload__text__text">{{ uploadText }}</span>
          <!-- <div>
            <i class="el-icon-upload"></i>
            <em>添加文件</em>
            <span>{{ fileList.length }}/{{ limit }}</span>
            <br />
            <span>单个文件不超过 {{ fileSize }}M</span>
          </div> -->
        </div>
      </el-upload>

    </div>
    <div class="el-upload__text__tip" v-if="isTextType">
      <span>单个文件不超过 {{ fileSize }}M{{ limit > 1 ? `，文件数量 ≤ ${limit}个` : '' }}</span>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'CoreUpload',
  data() {
    return {
      uploadText: '',
      uploadFileList: [],
    }
  },
  computed: {
    isShow() {
      const { showUploadBtnByLimit, fileList, isTextType } = this
      const flag =
        (showUploadBtnByLimit
          ? fileList.length < showUploadBtnByLimit
          : fileList.length < 30) || isTextType
      return flag && !this.readonly
    },
    textUploadDisabled() {
      return this.disabled || (this.limit > 1 && this.fileList.length >= this.limit)
    },
  },
  props: {
    isTextType: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    isAlone: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: 'file',
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    listType: {
      type: String,
      default: 'picture-card',
    },
    showUploadBtnByLimit: {
      type: Number,
      default: null,
    },
    fileSize: {
      type: [String, Number],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    beforeUpload: Function,
  },
  watch: {
    fileList: {
      handler(val) {
        this.uploadFileList = cloneDeep(val)
        const { fileList, limit } = this
        if (fileList.length === 0) {
          this.uploadText = '上传文件'
        } else if (fileList.length >= limit && limit === 1) {
          this.uploadFileList = []
          this.uploadText = '重新上传文件 '
        } else if (fileList.length < limit) {
          this.uploadText = '继续上传文件'
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    uploadRequest({ file }) {
      this.$emit('uploadRequest', file, this.fileList.length === this.limit)
    },
    beforeUploadHandler(file) {
      return this.beforeUpload(file)
    },
    errorHandle(err) {
      this.$meit('errorHandle', err)
    },
    exceedHandle(files, fileList) {
      this.$emit('exceedHandle', files, fileList)
    },
    // eslint-disable-next-line vue/no-unused-properties
    clearFile() {
      this.$refs.uploadCommon.clearFiles()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
::v-deep .el-upload__image__icon {
  width: 24px;
  height: 24px;
  background: url('../assets/ic-uploadImage@2x.png');
  background-size: cover;
}
::v-deep .el-upload__text {
  width: 128px;
  height: 32px;
  border: 1px solid #E5E6EB;
  border-radius: 6px;
  &__icon {
    width: 16px;
    height: 16px;
    background: url('../assets/ic-uploadText@2x.png');
    background-size: cover;
  }
  &__text {
    color: #1D2129;
    margin-left: 6px;
    font-size: 14px;
  }
}
.el-upload__text__tip {
  margin-top: 0;
  color: #86909C;
  font-size: 14px;
  line-height: 22px;
}
.text-upload-disabled {
  background: #F2F3F5;
  border: 1px solid #E5E6EB;
  color: #C9CDD4;
  .el-upload__text__text {
    color: #C9CDD4;
  }
  .el-upload__text__icon {
    background-image: url('../assets/ic-uploadText-disabled@2x.png');
  }
}
</style>
